import React from 'react';
import { Notes } from '../Notes';

interface PatientNotesProps {
    enableOpenModal?: boolean;
    entityId: number;
    patient: PatientType;
}
export function PatientNotes({ enableOpenModal = false, entityId, patient }: PatientNotesProps) {
    return <Notes enableOpenModal={enableOpenModal} entityId={entityId} patient={patient} />;
}
